import CategoryCoverListing from "./CategoryCoverListing";

export default CategoryCoverListing;